import type { TableSemanticSchema } from './types';

export const ComparisonSchema: TableSemanticSchema = {
  id: 'comparison',
  name: 'Comparison Matrix',
  description:
    'Option-by-criterion comparison. Scores roll up into a winner flag; downstream scorecard can import rows directly.',
  cells: [],
  itemFields: [
    { key: 'optionId', label: 'Option', kind: 'id', required: true },
    { key: 'criterionId', label: 'Criterion', kind: 'id', required: true },
    { key: 'score', label: 'Score', kind: 'number', description: '1 (worst) to 5 (best)' },
    { key: 'notes', label: 'Notes', kind: 'string' },
    { key: 'winnerFlag', label: 'Winner', kind: 'boolean' },
  ],
  computedFields: [
    { key: 'total', label: 'Total Score',
      expression: { op: 'sum', operands: ['score'] } },
    { key: 'rank', label: 'Rank',
      expression: { op: 'rank', field: 'total', direction: 'desc' } },
  ],
  renderingHints: { layout: 'grid' },
};
